/**
 * App Config, Config, Email Preview, Email Preferences,
 * API Keys, Version, External, INSEE, Unsubscribe endpoints
 */

export const appConfigEndpoints = {
  list: () => `/api/app-config`,
  setConfig: () => `/api/app-config`,
  uploadRib: () => `/api/app-config/rib`,
  downloadRib: () => `/api/app-config/rib/download`,
}

export const configEndpoints = {
  googleMapsKey: () => '/api/config/google-maps-key'
}

export const emailPreviewEndpoints = {
  preview: () => '/api/email-preview'
}

export const emailPreferencesEndpoints = {
  me: () => '/api/email-preferences/me'
}

export const userPreferencesEndpoints = {
  me: () => '/api/user-preferences/me'
}

export const apiKeysEndpoints = {
  list: () => '/api/api-keys',
  create: () => '/api/api-keys',
  update: (id) => `/api/api-keys/${id}`,
  delete: (id) => `/api/api-keys/${id}`,
  regenerate: (id) => `/api/api-keys/${id}/regenerate`
}

export const versionEndpoints = {
  check: () => '/api/version'
}

export const externalEndpoints = {
  health: () => '/api/external/health'
}

export const inseeEndpoints = {
  siret: () => '/api/public/insee/siret'
}

export const unsubscribeEndpoints = {
  status: () => '/api/public/unsubscribe/status',
  unsubscribe: () => '/api/public/unsubscribe',
  resubscribe: () => '/api/public/unsubscribe/resubscribe'
}

export const debugEndpoints = {
  getClock: () => '/api/debug/clock',
  setClock: () => '/api/debug/clock',
  listJobs: () => '/api/debug/jobs',
  triggerJob: (jobName) => `/api/debug/jobs/${jobName}`,
  cleanDbGroups: () => '/api/debug/clean-db/groups',
  cleanDb: () => '/api/debug/clean-db/clean',
  smsList: () => '/api/debug/sms',
  sms: (id) => `/api/debug/sms/${id}`,
  smsClear: () => '/api/debug/sms',
  smsTest: () => '/api/debug/sms/test',
  emailsList: () => '/api/debug/emails',
  email: (id) => `/api/debug/emails/${id}`,
  emailHtml: (id) => `/api/debug/emails/${id}/html`,
  emailsClear: () => '/api/debug/emails'
}
